import api from '../api';
import axios from 'axios';
import { Capacitor } from '@capacitor/core';

const isNativeApp = Capacitor.isNativePlatform();

//Skip the api.js refreshToken 401 handling
export async function login(email, password) {
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/auth/login`, {
        email,
        password,
        isNativeApp 
    }, 
    {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
        }
    });

    return response.data;
}

export async function loginWithGoogle(token, name) {
    const response = await api.post('/auth/google-login', { token, name, isNativeApp });
    return response.data;
}

export async function loginWithApple(token, name) {
  const response = await api.post('/auth/apple-login', { token, name, isNativeApp });
  return response.data;
}

export async function register(name, email, password) {
    const response = await api.post('/auth/register', { name, email, password, isNativeApp });
    return response.data;
}

export async function changePassword(currentPassword, newPassword) {
    const response = await api.post('/auth/change-password', { currentPassword, newPassword });
    return response.data;
}

export async function logoutUser() {
    await api.post('/auth/logout');
} 